<template>
  <div>
    <Header :title="'历史记录'"/>
    <van-tabs v-model="active" title-active-color="#004099" color="#004099" @change="changtab" :disabled="showDisabled">
      <van-tab title="全部" ref="panel" :disabled="showDisabled">
    
      </van-tab>
      <van-tab title="待处理" :disabled="showDisabled"> 

      </van-tab>
      <van-tab title="处理中" :disabled="showDisabled">

      </van-tab>
      <van-tab title="已完成" :disabled="showDisabled">
         
      </van-tab>
    </van-tabs>
     <van-empty description="暂无数据" v-if="list==''&&showempty"/>
     <van-loading size="24px" v-if="showloading" class="loadings">加载中...</van-loading>
     <van-panel :title="item.wentfl" :desc="item.wentms"  v-for="(item,index) in list" :key="index">
          <div class="titles" @click="godetail(item.orderId)" >
            <span>{{item.orderTitle}}</span>
            <span :class="item.type=='待审核'?'green':item.type=='进行中'?'hongse':item.type=='已完成'?'close':item.type=='已分配'?'yifenp':'green'">{{item.type }}</span>
          </div>
          <div class="contents" @click="godetail(item.orderId)" >{{item.orderDesc}}</div>
          <div slot="footer" class="date">
            <span>问题处理时长 ： {{item.processingTime}}</span>
          </div>
          <div slot="footer" class="date">
            <span>是否已评价 ： {{item.whetherEvaluate}}</span>
          </div>
          <div slot="footer" class="date">
            <span>登记日期 ： {{item.registerDate}}</span>
            <van-button type="primary" v-if="item.type=='已解决'||item.type=='待审核'" @click="closed(item,3,'关闭')">关闭</van-button>
            <van-button type="primary" v-if="item.type=='已关闭'&&(item.endTime!=null || (item.endTime==null&&item.unsolvedNum>0))" @click="pingjia(item)">评价</van-button>
            <van-button type="primary" v-if="item.type=='已解决'" @click="chongkai(item,6,'未解决')">未解决</van-button>
          </div>
      </van-panel>
    
    <scroll :onBottom="onBottom"></scroll>

    <van-dialog v-model="show" title="评价" @confirm="confirms">
      <div class="pingjiadiv">
           <span class="pjleft">是否解决：</span>
           <van-radio-group v-model="radio">
              <van-radio name="1">已解决</van-radio>
              <van-radio name="0">未解决</van-radio>
           </van-radio-group>
      </div>
       <div class="pingjiadiv">
           <span class="pjleft">评分：</span>
           <van-rate
            v-model="value"
            :size="25"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee" class="pjright" />
       </div>
        <div class="pingjiadiv">
           <span class="pjleft">评价内容：</span>
           <van-field
              ref="textarea"
              v-model="content"
              rows="3"
              autosize
              type="textarea"
              show-word-limit
              maxlength="50"
              class="pjright"
              placeholder="请输入评价内容"
            />
       </div>
       <div class="pingjiadiv_last" v-if="isShow">
           <span class="pjleft_last">问题提交当天是否有客服人员联系，沟通预约处理时间？：</span>
           <van-radio-group v-model="dayContact">
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否</van-radio>
           </van-radio-group>
      </div>
    </van-dialog>
    <van-dialog v-model="showck" title="未解决" @confirm="confirmsck">
        <div class="pingjiadiv">
           <span class="pjleft">未解决原因：</span>
           <van-field
              ref="textarea"
              v-model="reopenReason"
              rows="3"
              autosize
              type="textarea"
              show-word-limit
              maxlength="50"
              class="pjright"
              placeholder="请输入评价内容"
            />
       </div>
    </van-dialog>
  </div>
</template>

<script>
import { Tab, Tabs ,Panel,Field, Toast } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Loading } from 'vant';

import { Button } from 'vant';
import { Dialog } from 'vant';
import { Rate } from 'vant';
import { Empty } from 'vant';
import { mapState } from 'vuex'
import Scroll from '../../components/scroll.vue'
import Header from '../../components/backheader.vue'
  export default {

    activated(){
      // this.getRecord(null,this.page == 1 ?  true  : false )
    },
    created() {
      // this.getRecord()
      
    },
    beforeRouteEnter:(to,from,next)=>{
      console.log(from.name)
      if(from.name == "FeedBack"){
        next(vm=>{
           vm.page = 1;
           vm.list  = []
           vm.newlist  = []
           vm.getRecord(null,false,"FeedBack")
        })
      }else if(from.name == "HistoryDetail"){
        next(vm=>{
           vm.list  = []
           vm.newlist  = []
          if(vm.list.length == 0){
             vm.getRecord(null,false)
          }else{
            vm.getRecord(null,true)
          }
        })
      }else{
        next(vm=>{
           vm.list  = []
           vm.newlist  = []
           vm.getRecord()
        })
      }
    },
    computed: {
      ...mapState({
      'userinfo': state=>state.user.userinfo
      })
    },
    mounted(){
      this.changestatus()
    },
    components : {
      Scroll,
      Header,
      [Tabs.name]:Tabs,
      [Panel.name]:Panel,
      [Tab.name]:Tab,
      [Button.name]:Button,
      [Field.name]:Field,
      [Dialog.Component.name]: Dialog.Component,
      [Rate.name]:Rate,
      [Empty.name]:Empty,
      [Loading.name]:Loading,
      [Radio.name]:Radio,
      [RadioGroup.name]:RadioGroup
    },
    data(){
      return {
        list : [],
        newlist : [],
        content:"",
        showck:false,
        active : 0,
        reopenReason:"",
        page : 1,
        radio:'1',
        showloading:true,
        iClick:false,
        value:0,
        showList:false,
        showDisabled:false,
        show:false,
        pageSize : 10,
        orderid:"",
        status : 10,
        key : true,
        showempty:false,
        dayContact:null,
        isShow:false
        
      }
    },
    methods : {
      chongkai(row){
         this.showck = true
         this.orderid = row.orderId
         this.types = row.type
         this.reopenReason = ""
      },
      onBottom(callback){
        this.page += 1;
        // console.log(this.page)
        this.getRecord(callback)
      },
      async closed(item,status,word){
        var _this = this
        Dialog.confirm({
          title: '提示',
          message: '您确定要'+word+'吗？',
        }).then(() => {
          var type = "";
          if(item.type =='待审核'){
              type="10"
          }else if(item.type =='待分配'){
              type="11"
          }else if(item.type =='已分配'){
              type="12"
          }else if(item.type =='进行中'){
              type="13"
          }else if(item.type =='已解决'){
              type="14"
          }else if(item.type =='未解决'){
              type="15"
          }else if(item.type =='已关闭'){
              type="16"
          }else if(item.type=='已评价'){
              type="17"
          }
            var params = {
              operType:status,
              currentType:type,
              orderId:item.orderId,
              projectId:item.registererProject,
              orderTitle:item.orderTitle
            }
           
            var _this = this
            this.$http.post(`/mobile/order/orderOperate`,params,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then(function(res){
              if(res.data.code==200){
                Toast("操作成功");
                _this.show = false;
                _this.list.forEach(function(res1,index){
                  if(res1.orderId==item.orderId){
                    if(word=='未解决'){
                       item.type = '未解决'
                    }else{
                       item.type = '已关闭'
                    }
                   
                    _this.$set(_this.list,index,item)
                  }
                })
              }
            })
            
           
        })
      },
      pingjia(row){
        // console.log(row)
        this.show = true
        this.orderid = row.orderId
        this.types = row.type
        this.value = 0
        this.content = ""
        if(row.startTime != '' && row.startTime != null) {
          let date1 = row.registerDate.substring(0,10)
          let date2 = row.startTime.substring(0,10)
          if (date1 != date2) {
            this.isShow = true
            // console.log(row.orderTitle)
            // console.log(date1,date2)
          } else {
            this.isShow = false
          }
        };
      },
      async confirms(){
        if(this.value== 0){
          Toast("评分不能为空");
          this.show=true
          return
        }
        var type = "";
        if(this.types =='待审核'){
            type="10"
        }else if(this.types =='待分配'){
            type="11"
        }else if(this.types =='已分配'){
            type="12"
        }else if(this.types =='进行中'){
            type="13"
        }else if(this.types =='已解决'){
            type="14"
        }else if(this.types =='未解决'){
            type="15"
        }else if(this.types =='已关闭'){
            type="16"
        }else if(this.types=='已评价'){
            type="17"
        }
        var params = {
          evaluateStar:this.value,
          operType:7,
          currentType:type,
          solveFlag:this.radio,
          orderId:this.orderid,
          dayContact:this.dayContact
        }
        if(this.content!=""){
          params.orderEvaluate = this.content
        }
        var _this = this
        const res = await this.$http.post(`/mobile/order/orderOperate`,params,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        if(res.code==200){
          Toast("评价成功");
          this.show = false;
          this.list.forEach(function(res1,index){
            if(res1.orderId==_this.orderid){
              res1.type = "已评价"
              _this.$set(_this.list,index,res1)
            }
          })
        }
      },
     async confirmsck(){
        if(this.reopenReason==""){
          Toast("未解决内容不能为空");
          return
        }
        var type = "";
        if(this.types =='待审核'){
            type="10"
        }else if(this.types =='待分配'){
            type="11"
        }else if(this.types =='已分配'){
            type="12"
        }else if(this.types =='进行中'){
            type="13"
        }else if(this.types =='已解决'){
            type="14"
        }else if(this.types =='未解决'){
            type="15"
        }else if(this.types =='已关闭'){
            type="16"
        }else if(this.types=='已评价'){
            type="17"
        }
        var params = {
          operType:6,
          currentType:type,
          reopenReason:this.reopenReason,
          orderId:this.orderid,
          dayContact:this.dayContact
        }
        var _this = this
        const res = await this.$http.post(`/mobile/order/orderOperate`,params,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        if(res.code==200){
          Toast("评价成功");
          this.showck = false;
          this.list.forEach(function(res1,index){
            if(res1.orderId==_this.orderid){
              res1.type = "未解决"
              _this.$set(_this.list,index,res1)
            }
          })
        }
      },
      async getRecord(callback,key,from){
        this.newlist = []
        const res = await this.$http.get(`/mobile/order/query`,{params:{findType:this.status,pageNum:this.page,pageSize:this.pageSize},headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        this.newlist = key?[]:res.rows;

        if(this.list!='' && this.list.length>=res.total){
          return
          
        }
        this.list = [...this.list,...this.newlist]
        
        if(this.list!=''){
          this.list.map(function(res){
            if(res.type ==10){
                res.type="待审核"
            }else if(res.type ==11){
                res.type="待分配"
            }else if(res.type ==12){
                res.type="已分配"
            }else if(res.type ==13){
                res.type="进行中"
            }else if(res.type ==14){
                res.type="已解决"
            }else if(res.type ==15){
                res.type="未解决"
            }else if(res.type ==16){
                res.type="已关闭"
            }else if(res.type ==17){
                res.type="已评价"
            }
          })
        }
        if(this.list==''){
          this.showempty=true
        }
        this.showloading=false
        this.showDisabled=false
      //  this.changestatus()
        if(!callback)return
        callback()
      },
      changestatus(){
        if(this.$route.name != "HistoryList") return
        this.$nextTick(()=>{
          var groupcell = document.getElementsByClassName('van-cell-group');
          var titlecell = document.getElementsByClassName('van-cell__title');
          for (let index = 0; index < groupcell.length; index++) {
            if(!groupcell[index] || !titlecell[index]) return
            groupcell[index].style.borderBottom = "10px solid #ebedf0"
            titlecell[index].style.width = "286px"
            titlecell[index].style.flex = "none"
            titlecell[index].style.webkitFlex = "none"
          }
          var cell = document.getElementsByClassName('van-panel__header-value');
          for (let index = 0; index < cell.length; index++) {
            switch (cell[index].children[0].innerText) {
              case '待处理':
                cell[index].style.color="#00b949"
                break;
              case '处理中':
                cell[index].style.color="#ff8300"
                break;
              case '已完成':
                cell[index].style.color="#ff0000"
                break;
              default:
                break;
            }
          }
        })
      },
      changtab(){
        this.showloading=true
        if(this.showDisabled==true){
          return
        }
        this.showDisabled=true
        this.changestatus()
        this.newlist = []
        this.list = []
        this.page = 1;
        if(this.active =='0'){
           this.status = 10
        }else if(this.active =='1'){
           this.status = 11
        }else if(this.active =='2'){
           this.status = 12
        }else if(this.active =='3'){
            this.status = 13
        }
        var _this = this
        setTimeout(function(res){
          _this.getRecord()
        },100)
      },
      godetail(id){
        this.$router.push({
          path : `/historylist/historydetail/${id}`
        })
      }
    }
  }
</script>
<style>
.van-cell__label{
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}
</style>
<style scoped>
.date{
  color: #969799;
  font-size: 12px;
  line-height: 18px;
}
.titles{
  width:100%;
  display: flex;
  margin: 1% auto;
  justify-content: space-between;
}
.titles span{
  font-size: 14px;
  
}
.titles span:first-child{
  font-size: 16px;
  color:#000;
}
.loadings{
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding-top:25%;
  display: flex;
  justify-content: center;
}
.contents{
  width:100%;
  margin:1.5% auto;
  font-size: 14px;
  color:#666;
}
/deep/ [class*=van-hairline]::after,.van-cell::after{
  border:0;
}
/deep/ .van-panel{
  border-bottom: 1px solid #eee;
  width: 92%;
  margin: auto;
  padding:1% 0 2% 0;
}
/deep/ .van-panel__footer{
  padding:0;
}
/deep/ .van-cell{
  padding:2px;
}
/deep/ .van-tabs__content{
  border-top:7px solid #f4f4f4;
}
.green{
  color:green
}
.hongse{
  color:red
}
.chengse{
  color:orange
}
.close{
  color: #888;
}
.yifenp{
  color:orange
}
.date{
  width:100%;
  display: table;
}
.date>span{
  color: #969799;
  font-size: 12px;
  float: left;
}
/deep/ .van-button{
  padding:2px 9px;
  height: 26px;
  float: right;
  margin-top:-5px;
  margin-left: 6px;
}
.pingjiadiv{
  width: 92%;
  margin: 3% auto 0;
  display: flex;
}
.pingjiadiv_last {
  width: 92%;
  margin: 3% auto 2%;
}
.pjleft_last{
  font-size: 14px;
  color: #666;
  margin:4px 5px 0 0;
}
.pjleft{
  font-size: 14px;
  color: #666;
  margin:4px 5px 0 0;
  width: 80px;
}
.pjright{
  width:70%
}
/deep/ .van-dialog__footer .van-button{
  margin-bottom: 3%;
}
/deep/ .van-dialog__header{
  padding:9px 0 5px 0;
}
.tishiText{
    width: 100%;
    text-align: center;
    color: red;
    background: cornsilk;
    font-size: 14px;
    padding: 1% 0;
    margin-bottom: 1%;
}
/deep/ .van-radio-group{
  width:79%;
  display: flex;
  margin-top:3px;
}
/deep/ .van-radio{
  width: 50%;
}
/deep/ .van-radio__label{
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/pages/historylist/index.vue